import React from "react";

import { rest } from "@auto/services";
import { getServiceUri } from "@auto/metadata";
import { can } from "@src/security/permissions";

import {
  OperatorAccountRequestDetailsWidget
} from "@auto/users/__OperatorAccountRequestDetailsWidget";

/*
 * Developer-owned composition point for operator_account_request_annex.
 */
const loadAnnex = async () => null;
const renderAnnex = () => null;

const approveRequest = async (request) => {
  return await rest.request(
    getServiceUri() + "operator-account-request/" + encodeURIComponent(request.gid) + "/approve",
    "POST",
    {}
  );
};

const rejectRequest = async (request) => {
  return await rest.request(
    getServiceUri() + "operator-account-request/" + encodeURIComponent(request.gid) + "/reject",
    "POST",
    {}
  );
};

export const displayOperatorAccountRequest = (gui, id) => ({
  uuid: `operator-account-request-${id}`,
  view: () => (
    <OperatorAccountRequestDetailsWidget
      gui={gui}
      id={id}
      canManage={can(gui, "MANAGE_OPERATOR_USER")}
      approveRequest={approveRequest}
      rejectRequest={rejectRequest}
      loadAnnex={loadAnnex}
      renderAnnex={renderAnnex}
    />
  )
});

export default displayOperatorAccountRequest;
